/***
 * 浏览器打印
 */
import { printTemplateCompile } from './print-template-compile'
import { pgMessage } from '../../message/index'
export async function browser({ compileDatas, printTemplate }) {
  const { printTemplateContents } = await printTemplateCompile({
    compileDatas,
    printTemplate,
    html: true,
  })
  if (!printTemplateContents?.length) {
    pgMessage.error(`因数量为零的数据已过滤,目前无打印数据~`)
    return Promise.reject()
  }

  const batch = printTemplate.batch > 0 ? printTemplate.batch : 1
  let temp = batch
  const content = printTemplateContents.reduce((pre, cur) => {
    const _print_ = Number(cur._print_ && cur._print_ !== 'undefined' ? cur._print_ : 1)
    for (let i = 0; i < _print_; i++) {
      pre += `${
        temp == batch
          ? '<div style="page-break-after: always; width:' +
            printTemplate.print.width +
            'mm; height:' +
            printTemplate.print.height +
            'mm">'
          : ''
      }${cur.content}${temp - 1 == 0 ? '</div>' : ''}`
      temp -= 1
      if (temp == 0) temp = batch
    }
    return pre
  }, '')

  //开始浏览器打印
  var docStr = `<!DOCTYPE html>
      <html lang="zh-CN" style="margin:0;padding:0">
      <head>
          <meta>
          ${printTemplate.style ? printTemplate.style : ''}
      </head>
      <body style="margin:0;padding:0"><div id="pgPrintWindow">${content}</div></body>
      </html>`
  //打印内容写入newWindow文档
  const newIframe = window.document.createElement('iframe')
  newIframe.setAttribute('name', 'browser-print')
  newIframe.style.display = 'none'
  window.document.body.appendChild(newIframe)

  var newWindow = window.open('打印窗口', 'browser-print')
  newWindow.document.write(docStr)
  // {/* <img */}
  if (/<img /.test(docStr)) {
    const imgs = newWindow.document.getElementsByTagName('img')
    const successArr = []
    for (let item of imgs) {
      item.onload = function () {
        successArr.push('success')
        if (successArr.length === imgs.length) {
          newWindow.document.close()
          //调用打印机
          newWindow.print()
          // 关闭newWindow页面
          newWindow.close()
          newWindow.document.body.remove()
          window.document.body.removeChild(newIframe)
        }
      }
    }
  } else {
    //关闭文档
    newWindow.document.close()
    //调用打印机
    newWindow.print()
    // 关闭newWindow页面
    newWindow.close()
    newWindow.document.body.remove()
    window.document.body.removeChild(newIframe)
  }
}
